$(document).ready(function() {
    $('.dropdown-button-faq').click(function() {
        $(this).next('.tabs-nav-faq').toggleClass('active');
        $(this).toggleClass('rotate-icon-faq');
    });

    $('.tabs-nav-faq').each(function() {
        $(this).find('li:first-child').addClass('active');
    });

    $('.tabs-content').each(function() {
        $(this).children().hide();
        $(this).children().first().show();
    });
    
    $('.tabs-nav-faq li').click(function(){
        var $parentNav = $(this).closest('.tabs-nav-faq');
        var $parentContent = $parentNav.parent().parent().next('.tabs-content');

        $parentNav.find('li').removeClass('active');
        $(this).addClass('active');
        $parentContent.children().hide();

        let activeTab = $(this).find('a').attr('href');
        $parentContent.find(activeTab).fadeIn();

        // change dropdown button text
        let selectedTitle = $(this).find('a').data('tabtitle');
        $parentNav.prev('.dropdown-button-faq').html(selectedTitle);

        // close dropdown only if 'active' class is already present
        if ($parentNav.hasClass('active')) {
            $parentNav.toggleClass('active');
            $parentNav.prev('.dropdown-button-faq').toggleClass('rotate-icon-faq');
        }

        return false;
    });
});
